@if ((!authService.isLoggedInAuth0() || isLoggingIn) && router.url !== '/register' && router.url !==
'/outage') {
<aix-loading></aix-loading>
} @if (authService.isLoggedInAuth0()) {
<aix-nav-bar class="hide-if-print"></aix-nav-bar>
<!-- Persistent support-chat bubble; self-gates on the pylonChat tenant feature and hides once the
     real Pylon widget boots. See AixPylonLauncherComponent (trade-platform/trade-platform#10468). -->
<aix-pylon-launcher></aix-pylon-launcher>
}
<div class="u-relative hide-if-print">
    <div class="container u-relative">
        <aix-flash-messages></aix-flash-messages>
    </div>
</div>

<aix-inactivity-modal (logout)="logout()"></aix-inactivity-modal>

<!-- Sponsor event communications the user must acknowledge. Self-gates on there being a pending
     message; the fetch is dispatched from the login machine. -->
<aix-announcements-modal></aix-announcements-modal>

<div id="app" [class.register]="router.url === '/register'">
    <router-outlet></router-outlet>
</div>

@if (authService.isLoggedInAuth0()) {
<aix-footer class="hide-if-print"></aix-footer>
}
